import {
    ContactUsContainer,
    ContactUsTitle,
    ContactUsBannerContainer,
    ContactUsBannerContent,
    ContactUsBannerText,
    ContactUsBannerButton,
} from './styled';
import Locations from 'components/Locations';
import ContactUsForm from 'components/ContactUsForm';
import { openHubspotChat } from 'global/globalState';
import Breadcrumb from 'components/Breadcrumb';

function ContactUs() {
    return (
        <ContactUsContainer>
            <Breadcrumb pageTitle='Contact Us'/>
            <ContactUsTitle>Contact Us</ContactUsTitle>

            <Locations isWeHaveToShowYou={false} />

            <ContactUsForm />

            <ContactUsBannerContainer>
                <ContactUsBannerContent>
                    <ContactUsBannerText>
                        Schedule a free consultation with one of our technology experts. <br/>
                        Ask about our live, remote technology demos.
                    </ContactUsBannerText>
                    <ContactUsBannerButton onClick={openHubspotChat}>
                        Speak with a Design Specialist
                    </ContactUsBannerButton>
                </ContactUsBannerContent>
            </ContactUsBannerContainer>
        </ContactUsContainer>
    );
}

export default ContactUs;
